import React from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Grid,
  Card,
  CardContent,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { Notifications, CalendarToday, Home } from "@mui/icons-material";

function LegalprivacyPolicy() {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* AppBar */}
        <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Good Morning, John!
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar>

        {/* Breadcrumbs */}
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            mb: 2,
            fontSize: "0.875rem",
            color: "black",
          }}
        >
          <Link
            underline="hover"
            color="inherit"
            href="vendor-dashboard"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
            }}
          >
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Typography
            color="text.primary"
            sx={{ fontWeight: "bold", fontSize: "0.875rem" }}
          >
            Legal Policy Information
          </Typography>
        </Breadcrumbs>

        <Grid container spacing={2} style={{ padding: 16 }}>
          <Grid item xs={12}>
            {/* Card */}
            <Card
              style={{
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: 16,
              }}
            >
              <CardContent>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  {/* Header */}
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                      marginBottom: 8,
                      color: "black",
                    }}
                  >
                    Legal Policy Information
                  </Typography>

                  {/* Repeating Content */}
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Typography
                      key={index}
                      variant="body2"
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: 1.6,
                        color: "black",
                      }}
                    >
                      Contrary to popular belief, Lorem Ipsum is not simply
                      random text. It has roots in a piece of classical Latin
                      literature from 45 BC, making it over 2000 years old.
                      Richard McClintock, a Latin professor at Hampden-Sydney
                      College in Virginia, looked up one of the more obscure
                      Latin words, consectetur, from a Lorem Ipsum passage, and
                      going through the cites of the word in classical
                      literature, discovered the undoubtable source.
                    </Typography>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default LegalprivacyPolicy;
